import {omneticApi} from '@dms/api/base';
import {
  GetLicensingLogApiResponse,
  GetLicensingLogApiArg,
  ListTenantLicensesApiResponse,
  ListTenantLicensesApiArg,
  GetUseCaseListApiResponse,
  GetUseCaseListApiArg,
} from '@dms/api/shared';

export const licensingApi = omneticApi.injectEndpoints({
  endpoints: (build) => ({
    getLicensingLog: build.query<GetLicensingLogApiResponse, GetLicensingLogApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/licensing/log`,
        params: {from: queryArg.from, to: queryArg.to},
      }),
    }),
    listTenantLicenses: build.query<ListTenantLicensesApiResponse, ListTenantLicensesApiArg>({
      query: () => ({
        url: `/dms/v1/licensing/tenant-license`,
      }),
    }),
    getUseCaseList: build.query<GetUseCaseListApiResponse, GetUseCaseListApiArg>({
      query: () => ({
        url: `/dms/v1/licensing/use-case`,
      }),
    }),
  }),
});

export const {useGetLicensingLogQuery, useListTenantLicensesQuery, useGetUseCaseListQuery} =
  licensingApi;
